// OLD CODE ENaDS USE IT FOR REFERENCE


import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { BehaviorSubject, Subscription } from 'rxjs';
import { first, map } from 'rxjs/operators';
import firebase from 'firebase/app'; // Make sure this is imported at the top
import { Router } from '@angular/router';

export type CallMode = 'video' | 'voice' | 'chat'|'';
@Injectable({ providedIn: 'root' })

export class VideoCallService {
  private localStreamBs = new BehaviorSubject<MediaStream>(null);
  public localStream$ = this.localStreamBs.asObservable();
  private remoteStreamBs = new BehaviorSubject<MediaStream>(null);
  public remoteStream$ = this.remoteStreamBs.asObservable();
  public isCallStarted$ = new BehaviorSubject<boolean>(false);

  // In-app "minimize" state: lets the full video-consultation screen hand off
  // to a small floating widget (rendered once, outside the router-outlet, in
  // AppComponent) instead of relying on the browser's native Picture-in-Picture,
  // which closes automatically the moment Angular destroys the source <video>
  // on route navigation. The underlying streams above are untouched by either
  // component's lifecycle, so the call keeps running either way.
  public isMinimized$ = new BehaviorSubject<boolean>(false);
  public minimizedMeta$ = new BehaviorSubject<{ returnUrl: string; remotename?: string }>(null);

  minimizeCall(returnUrl: string, remotename?: string) {
    this.minimizedMeta$.next({ returnUrl, remotename });
    this.isMinimized$.next(true);
  }

  restoreCall() {
    this.isMinimized$.next(false);
  }

  isJoinedTo(roomId: string): boolean {
    return this.roomJoined && this.roomId === roomId;
  }

  isJoinedToOtherRoom(roomId: string): boolean {
    return this.roomJoined && !!this.roomId && this.roomId !== roomId;
  }

  private pc: RTCPeerConnection;
  private roomId: string;
  // private selfId: string = 'patient_' + Math.random().toString(36).substr(2, 9);
  private selfId: string = `patient-${Date.now()}`;

initSelf() {
  this.selfId = `patient-${Date.now()}`;
}

  
  private signalsSub: Subscription;
  private candidatesSub: Subscription;
  private participantsSub: Subscription;
  private signalingLocked = false;
  private roomJoined = false;
  private static cachedStream: MediaStream = null;
  private callMode: CallMode = 'video';


  // Ringing Mechanism

public incomingCall$ = new BehaviorSubject<any>(null);
public outgoingStatus$ = new BehaviorSubject<any>(null);
public outgoingStatusObservable$ = this.outgoingStatus$.asObservable();


public callPermission = false;
private ringtone = new Audio('assets/Ringtone.mp3');
private callRequestId: string = null;

  // 

  constructor(private afs: AngularFirestore, private router: Router,) {}


  async initLocalStream(mode: CallMode = 'video') {
    if (!this.localStreamBs.value) {

       const constraints =
      mode === 'voice'
        ? { video: false, audio: true }
        : { video: true, audio: true };
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      this.localStreamBs.next(stream);
    }
    return this.localStreamBs.value;
  }

  async createOrJoinRoom(roomId: string, mode: CallMode = 'video') {
  if (this.roomJoined) return;
  this.roomJoined = true;
  this.roomId = roomId;
  
  // 1. Show local video immediately to avoid black screen
  try {
    await this.initLocalStream(mode);
  } catch (err) {
    this.roomJoined = false;
    throw err;
  }

  if (mode === 'chat') {
  console.log('[VC] Chat mode - skipping WebRTC');
  return;
}

  const roomRef = this.afs.collection('rooms').doc(roomId);
  const signals = await roomRef.collection('signals').get().toPromise();
  signals.forEach(doc => doc.ref.delete());
  
  // 2. Start signaling listeners BEFORE joining
  this.startSignalingListeners(roomId);

  // 3. Register self in participants map

  await roomRef.get().toPromise().then(doc => {
  if (!doc.exists) {
    roomRef.set({
      createdBy: this.selfId,
      participants: { [this.selfId]: true }
    });
  } else {
    roomRef.update({
      [`participants.${this.selfId}`]: true
    });
  }
});

  // await roomRef.set({
  //   participants: { [this.selfId]: true }
  // }, { merge: true });

  // 4. THE FIX: Immediate check + Continuous listener
  // We use pipe(first()) to check the room state the moment we join
  // roomRef.valueChanges().pipe(first()).subscribe((data: any) => {
  //   this.decideSignalingRole(data);
  // });

  // Also listen for anyone joining after us
  // this.participantsSub = roomRef.valueChanges().subscribe((data: any) => {
  //   this.decideSignalingRole(data);
  // });
this.participantsSub = roomRef.valueChanges().subscribe((data: any) => {
  if (!data || !data.participants) return;
  const ids = Object.keys(data.participants);
 if (ids.length < 2) {
  console.log('[VC] Other participant left — waiting for rejoin');

  this.forceRemoteHangup();

  // clear old Firestore signals
  const sigRef = this.afs.collection('rooms')
    .doc(this.roomId)
    .collection('signals');

  sigRef.get().toPromise().then(snap => {
    snap.forEach(d => d.ref.delete());
  });

  return;
}

  // The moment 2 people are in, the signaling role is decided
  this.decideSignalingRole(data);
});
}


private forceRemoteHangup() {
  console.log('[VC] Remote left — resetting signaling state');

  if (this.pc) {
    this.pc.close();
    this.pc = null;
  }

  this.pendingIce = [];
  this.signalingLocked = false;   // REQUIRED
  this.remoteStreamBs.next(null);
  this.isCallStarted$.next(false);
}
private decideSignalingRole(data: any) {
 

  // ALWAYS unlock if pc is not truly connected
  if (!this.pc || this.pc.connectionState !== 'connected') {
    this.signalingLocked = false;
  }

  if (this.signalingLocked) return;
  if (!data?.participants) return;

  const ids = Object.keys(data.participants);

  if (!ids.includes(this.selfId)) {
    this.signalingLocked = false;
    return;
  }

  if (ids.length < 2) {
    this.signalingLocked = false;
    return;
  }

  const sorted = [...ids].sort((a, b) => a.localeCompare(b));

  const selfIndex = sorted.indexOf(this.selfId);
  if (selfIndex === -1) return;

  const otherId = selfIndex === 0 ? sorted[1] : sorted[0];
  const iAmCaller = this.selfId.localeCompare(otherId) < 0;

  if (this.pc && ['closed','failed','disconnected'].includes(this.pc.connectionState)) {
    this.pc.close();
    this.pc = null;
    this.signalingLocked = false;
  }

  if (iAmCaller && (!this.pc || this.pc.connectionState !== 'connected')) {
    console.log('[VC] I am CALLER vs', otherId);
    this.signalingLocked = true;
     setTimeout(() => this.initiateOffer(otherId), 100);
    // this.initiateOffer(otherId);
  } else {
    console.log('[VC] I am CALLEE vs', otherId);
  }

  console.info('[VC] roleCheck', {
  locked: this.signalingLocked,
  pc: this.pc?.connectionState,
  ids
});

}


  private async initiateOffer(remoteId: string) {
    if (this.pc) return; 
    this.pc = this.createPeerConnection(remoteId);
    
    const stream = this.localStreamBs.value;
    //stream.getTracks().forEach(track => this.pc.addTrack(track, stream)); WORKING VIDEO

    stream?.getTracks().forEach(track => {
  if (this.callMode === 'voice' && track.kind === 'video') return;
  this.pc.addTrack(track, stream);
}); // DYNAMIC VIDEO

    const offer = await this.pc.createOffer();
    await this.pc.setLocalDescription(offer);

    await this.afs.collection('rooms').doc(this.roomId).collection('signals').add({
      from: this.selfId,
      to: remoteId,
      type: 'offer',
      sdp: offer.sdp,
      timestamp: Date.now()
    });
  }
  private pendingIce: RTCIceCandidateInit[] = [];

private startSignalingListeners(roomId: string) {
  const roomRef = this.afs.collection('rooms').doc(roomId);

  // LISTEN FOR SIGNALS (Offers and Answers)
  this.signalsSub = roomRef.collection('signals').stateChanges(['added']).subscribe(async (changes) => {
    for (const change of changes) {
      const signal = change.payload.doc.data() as any;
      
      // ONLY process signals intended for ME from someone else
      if (signal.to !== this.selfId || signal.from === this.selfId) continue;

      if (signal.type === 'offer') {
        // If I receive an offer, I must become the Answerer
        console.log('[VC] Received offer from:', signal.from);
        await this.handleIncomingOffer(signal);
      } else if (signal.type === 'answer') {
        // If I receive an answer, I finish the handshake
        console.log('[VC] Received answer from:', signal.from);
        if (this.pc && this.pc.signalingState !== 'stable') {
          await this.pc.setRemoteDescription(new RTCSessionDescription(signal));
          this.flushIce(); 
          this.isCallStarted$.next(true);
        }
      }
    }
  });

  // LISTEN FOR ICE CANDIDATES
  this.candidatesSub = roomRef.collection('candidates').stateChanges(['added']).subscribe(changes => {
    changes.forEach(change => {
      const data = change.payload.doc.data() as any;
      if (data.to === this.selfId && data.from !== this.selfId) {
        // if (this.pc && this.pc.remoteDescription) {
        //   this.pc.addIceCandidate(new RTCIceCandidate(data)).catch(err => 
        //     console.error('[VC] Error adding ICE candidate:', err)
        //   );
        // }
        if (!this.pc) return;

        if (this.pc.remoteDescription) {
          this.pc.addIceCandidate(new RTCIceCandidate(data)).catch(console.error);
        } else {
          this.pendingIce.push(data);   //  store for later
        }

      }
    });
  });
}

  private async handleIncomingOffer(offer: any) {
    this.pc = this.createPeerConnection(offer.from);
    
    const stream = this.localStreamBs.value;
    // stream.getTracks().forEach(track => this.pc.addTrack(track, stream)); WORKING VIDEO

    stream?.getTracks().forEach(track => {
  if (this.callMode === 'voice' && track.kind === 'video') return;
  this.pc.addTrack(track, stream);
}); // DYNAMIC VIDEO

    await this.pc.setRemoteDescription(new RTCSessionDescription(offer));
    this.flushIce();
    const answer = await this.pc.createAnswer();
    await this.pc.setLocalDescription(answer);

    await this.afs.collection('rooms').doc(this.roomId).collection('signals').add({
      from: this.selfId,
      to: offer.from,
      type: 'answer',
      sdp: answer.sdp,
      timestamp: Date.now()
    });
    this.isCallStarted$.next(true);
  }

  private flushIce() {
  this.pendingIce.forEach(c => {
    this.pc.addIceCandidate(new RTCIceCandidate(c)).catch(console.error);
  });
  this.pendingIce = [];
}


private createPeerConnection(remoteId: string): RTCPeerConnection {
  const pc = new RTCPeerConnection({
    iceServers: [
      { urls: 'stun:stun.l.google.com:19302' },
       // UDP TURN (fastest)
    {
      urls: 'turn:57.159.29.101:3478?transport=udp',
      username: 'ezoturnvm1',
      credential: 'SBY31a54CCEMtzAMH0Ptg5v86'
    },

    // TCP TURN fallback
    {
      urls: 'turn:57.159.29.101:3478?transport=tcp',
      username: 'ezoturnvm1',
      credential: 'SBY31a54CCEMtzAMH0Ptg5v86'
    },

    // TLS TURN last
    {
      urls: 'turns:57.159.29.101:5349',
      username: 'ezoturnvm1',
      credential: 'SBY31a54CCEMtzAMH0Ptg5v86'
    }
      
    ]
  });

  pc.onicecandidate = e => {
    if (e.candidate) {
      this.afs.collection('rooms')
        .doc(this.roomId)
        .collection('candidates')
        .add({
          from: this.selfId,
          to: remoteId,
          candidate: e.candidate.candidate,
          sdpMid: e.candidate.sdpMid,
          sdpMLineIndex: e.candidate.sdpMLineIndex
        });
      }
    };

  pc.oniceconnectionstatechange = () => {
    const s = pc.iceConnectionState;
    console.log('[PC] ICE state:', s);
    if (s === 'failed' || s === 'disconnected') {
      console.warn('[VC] ICE failed → resetting');
      this.forceRemoteHangup();
    }
  };

  pc.onsignalingstatechange = () => {
    console.log('[VC] signaling:', pc.signalingState);
  };

  pc.onconnectionstatechange = () => {
    console.log('[PC] CONN state:', pc.connectionState);
    if (['failed','disconnected'].includes(pc.connectionState)) {
      this.signalingLocked = false;
    }
  };

  pc.ontrack = e => {
    if (e.streams && e.streams[0]) {
      this.remoteStreamBs.next(e.streams[0]);
    }
  };

  return pc;
}

  async endCall() {
  // 1. Unsubscribe from all listeners immediately
  this.signalsSub?.unsubscribe();
  this.candidatesSub?.unsubscribe();
  this.participantsSub?.unsubscribe();
  
  // 2. Stop the local media tracks
  if (this.localStreamBs.value) {
    this.localStreamBs.value.getTracks().forEach(t => t.stop());
    this.localStreamBs.next(null);
  }

  // 3. Close the PeerConnection
  if (this.pc) {
    this.pc.onicecandidate = null;
    this.pc.ontrack = null;
    this.pc.close();
    this.pc = null;
  }

  // 4. Update Firestore
  if (this.roomId && this.selfId) {
    const roomRef = this.afs.collection('rooms').doc(this.roomId).ref;
    
    // We use the native Firebase reference here for a fast, direct delete
    try {
      await roomRef.update({
        [`participants.${this.selfId}`]: firebase.firestore.FieldValue.delete()
      });
      console.log('[VC] Successfully left room');
    } catch (err) {
      console.warn('[VC] Cleanup failed during reload', err);
    }
  }

  this.remoteStreamBs.next(null);
  this.isCallStarted$.next(false);
  this.signalingLocked = false;
  this.roomJoined = false;
  VideoCallService.cachedStream = null;
  this.isMinimized$.next(false);
  this.minimizedMeta$.next(null);


}

  local_toggleVideo() {
    const t = this.localStreamBs.value?.getVideoTracks()[0];
    if (t) t.enabled = !t.enabled;
  }
  local_toggleMic() {
    const t = this.localStreamBs.value?.getAudioTracks()[0];
    if (t) t.enabled = !t.enabled;
  }

    remote_toggleVideo() {
    const t = this.remoteStreamBs.value?.getVideoTracks()[0];
    if (t) t.enabled = !t.enabled;
  }

  remote_toggleMic() {
    const t = this.remoteStreamBs.value?.getAudioTracks()[0];
    if (t) t.enabled = !t.enabled;
  }
  

getRemoteStream() {
  return this.remoteStreamBs.value;
}

getlocalStream() {
  const s = this.localStreamBs.value
  if (!s) return null;

  const dead = s.getTracks().every(t => t.readyState === 'ended');
  return dead ? null : s;
}

clearLocalStream() {
  this.localStreamBs.value.getTracks().forEach(t => t.stop());
  this.localStreamBs.next(null);
}

sendMessage(roomId: string, text: string) {
  if (!roomId || !text?.trim()) return;

  return this.afs.collection('rooms')
    .doc(roomId)
    .collection('messages')
    .add({
      from: this.selfId,
      text: text.trim(),
      time: firebase.firestore.FieldValue.serverTimestamp(), // safer than Date.now()
      read: false
    });
}


listen(roomId: string) {
  return this.afs.collection('rooms')
    .doc(roomId)
    .collection('messages', ref => ref.orderBy('time'))
    .valueChanges()
    .pipe(
      map((msgs: any[]) =>
        msgs.map(m => ({
          ...m,
          isMine: m.from === this.selfId
        }))
      )
    );
}

// Ringing Mechanism Starts
async startRinging(receiverId: string, roomId: string, mode: CallMode,name:string,selfId:string,appId:string,selfish:string) {

  // const id = this.afs.createId();
  // this.callRequestId = id;

    const id = selfId;
  this.callRequestId = id;

  const callRef = this.afs.collection('callRequests').doc(id);

  const docSnap = await callRef.ref.get();

  // If already exists and ringing → do nothing
  if (docSnap.exists) {
    const data: any = docSnap.data();
    if (data.status === 'ringing') {
      return;
    }
  }

  await this.afs.collection('callRequests').doc(id).set({
    callerId: selfish,
    receiverId,
    roomId,
    mode,
    status: 'ringing',
    createdAt: Date.now(),
    name:name,
    appointmentId:appId
  });

  this.listenOutgoingStatus(id);

    // AUTO REJECT AFTER 2 MINUTES
  setTimeout(async () => {

    const docSnap = await this.afs.collection('callRequests').doc(id).ref.get();

    if (!docSnap.exists) return;

    const data: any = docSnap.data();

    // If still ringing after 2 min → reject automatically
    if (data.status === 'ringing') {
      await this.afs.collection('callRequests').doc(id).set({
        status: 'rejected',
        rejectedBy: 'system',
        rejectedAt: Date.now()
      }, { merge: true });
    }

  }, 60000); // 45 Seconds 
}


private listenOutgoingStatus(id: string) {
  this.afs.collection('callRequests').doc(id)
    .valueChanges()
    .subscribe((data: any) => {

      if (!data) return;

      this.outgoingStatus$.next(data);

      if (data.status === 'accepted') {
        this.callPermission = true;
      }

      if (data.status === 'rejected') {
        // alert('Call Rejected');
      }
    });
}


listenIncomingCalls() {

  const selfId = localStorage.getItem('userFlag') == 'Physician'
    ? localStorage.getItem('physicianId')
    : localStorage.getItem('regID');

  this.afs.collection('callRequests', ref =>
    ref.where('receiverId', '==', selfId)
  )
  .valueChanges({ idField: 'id' })
  .subscribe((calls: any[]) => {

    const ringingCall = calls.find(c => c.status === 'ringing' && c.callerId !== selfId);

    if (ringingCall) {
      this.incomingCall$.next(ringingCall);
          if(this.router.url.includes('pages/video-consultation'))this.playRingtone();
    } else {
      this.stopRingtone();
      this.incomingCall$.next(null);
    }

  });
}

async acceptCall(call: any) {

  await this.afs.collection('callRequests')
    .doc(call.id)
    .set({ status: 'accepted' }, { merge: true });

  this.callPermission = true;

  this.stopRingtone();
  this.incomingCall$.next(null);
}

async backtoChatCall (call: any) {

  await this.afs.collection('callRequests')
    .doc(call?.id)
    .set({ status: 'Completed',
      rejectedBy: 'user',  
  rejectedAt: Date.now()
     }, { merge: true });
  this.incomingCall$.next(null);
}

async rejectCall(call: any) {

  await this.afs.collection('callRequests')
    .doc(call?.id)
    .set({ status: 'rejected',
      rejectedBy: 'user',  
  rejectedAt: Date.now()
     }, { merge: true });

  this.stopRingtone();
  this.incomingCall$.next(null);
}


private playRingtone() {
  this.ringtone.loop = true;
  this.ringtone.play().catch(() => {});
}

private stopRingtone() {
  this.ringtone.pause();
  this.ringtone.currentTime = 0;
}


async forceDeleteRoom(roomId: string) {
  try {
    const roomRef = this.afs.collection('rooms').doc(roomId).ref;

    const roomSnap = await roomRef.get();

    if (roomSnap.exists) {

      const collections = ['signals', 'candidates', 'messages'];

      for (const col of collections) {
        const snap = await roomRef.collection(col).get();

        const deletes = snap.docs.map(d => d.ref.delete());
        await Promise.all(deletes); 
      }

      await roomRef.delete();
      console.log('[VC] Room deleted');

    } else {
      console.warn('[VC] Room not found:', roomId);
    }

    const callSnap = await this.afs.collection('callRequests', ref =>
      ref.where('roomId', '==', roomId)
    ).get().toPromise();

    if (callSnap && !callSnap.empty) {

      const deletes = callSnap.docs.map(d => d.ref.delete());
      await Promise.all(deletes);

      console.log('[VC] callRequests deleted');

    } else {
      console.warn('[VC] No callRequests found for room:', roomId);
    }

    this.outgoingStatus$.next(null);
  } catch (err) {
    console.error('[VC] forceDeleteRoom error:', err);
  }
}



  private subscription: any;

   // DOCTOR → CREATE CHECK-IN
  async createCheckIn(doctorId: string, doctorName: string, patientId: string,date:string,callType:string,postId:number) {

    await this.afs.collection('checkIn').doc(patientId).set({
      doctorId,
      doctorName,
      patientId,
      status: 'waiting',
      createdAt: Date.now(),
      appDate: date,
      type: callType,
      postId: postId
    });

    // Auto delete if no response
    // setTimeout(async () => {
    //   const doc = await this.afs.collection('checkIn').doc(id).ref.get();
    //   if (doc.exists && (doc.data() as any)?.status === 'waiting') {
    //     await this.afs.collection('checkIn').doc(id).delete();
    //   }
    // }, 30000); // 30 sec
  }

  // PATIENT ACCEPT
  async acceptCheckIn(data: any) {
    await this.afs.collection('checkIn').doc(data?.patientId).set({
      status: 'accepted'
    }, { merge: true });
  }

  // PATIENT REJECT
  async rejectCheckIn(data: any) {
    await this.afs.collection('checkIn').doc(data?.patientId).set({
      status: 'rejected'
    }, { merge: true });
   // await this.afs.collection('checkIn').doc(data.id).delete();
  }

  
}

